import type {
	TicketDTO,
	TicketListResponse,
	TicketStatus,
} from "@zplanem/responses"
import { TICKET_BOARD_STATUSES } from "../../hooks/ticket-api-paths"

export function flattenTicketPages(pages: TicketListResponse[]): TicketDTO[] {
	return pages.flatMap((page) => page.tickets)
}

interface TicketStatusGroup {
	status: TicketStatus
	items: TicketDTO[]
}

/**
 * Buckets a flat ticket list into per-status groups in the board's status order
 * (open → in_progress → done → cancelled), dropping statuses with no loaded
 * tickets. Used by the List view. Note: with a paginated source, a group only
 * appears once one of its members has been loaded — the List signals "more may
 * exist" via a `+` on the count and the Load more control.
 */
export function groupTicketsByStatus(
	tickets: TicketDTO[],
): TicketStatusGroup[] {
	return TICKET_BOARD_STATUSES.map((status) => ({
		status,
		items: tickets.filter((ticket) => ticket.status === status),
	})).filter((group) => group.items.length > 0)
}
